import { memo, useCallback } from "react";
import { useLocation, useNavigate } from "react-router";
import { Button } from "antd";
import JoinWalkButton from "@/components/join-a-walk/JoinWalkButton";
import T from "@/components/common/T";

// Matches the Index page routes: "/", "/country/:countryCode", "/country/:countryCode/city/:cityCode"
const INDEX_PATH_PATTERN = /^\/(country\/[^/]+(\/city\/[^/]+)?)?\/?$/;

// Container clips the stacked tabs so only the outer-left corners round while
// the tabs join seamlessly with no gap. Sits flush against the right edge.
const TAB_GROUP_STYLE = {
    position: "fixed",
    right: 8,
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 1000,
    display: "flex",
    flexDirection: "column",
    borderTopLeftRadius: 12,
    borderBottomLeftRadius: 12,
    overflow: "hidden",
    boxShadow: "-3px 2px 14px rgba(0, 0, 0, 0.22)",
};

// Vertical tab with rotated (bottom-to-top) text; square corners — the
// container handles rounding so the two tabs sit flush against each other.
const TAB_BASE_STYLE = {
    writingMode: "vertical-rl",
    transform: "rotate(180deg)",
    height: 110,
    width: 32,
    padding: 0,
    fontWeight: 600,
    fontSize: 11,
    letterSpacing: 1,
    border: "none",
    borderRadius: 0,
    boxShadow: "none",
};

const JOIN_TAB_STYLE = {
    ...TAB_BASE_STYLE,
    background: "linear-gradient(180deg, #ff4d6d 0%, #ff6a88 100%)",
    color: "#fff",
};

const MAP_TAB_STYLE = {
    ...TAB_BASE_STYLE,
    background: "#0F172A",
    color: "#fff",
};

const FloatingActionsLayout = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const isIndexPage = INDEX_PATH_PATTERN.test(location.pathname);

    const goToMap = useCallback(() => navigate("/"), [navigate]);

    return (
        <div style={TAB_GROUP_STYLE}>
            {/* <JoinWalkButton style={JOIN_TAB_STYLE}><T k="JOIN A WALK" /></JoinWalkButton> */}
            {!isIndexPage && (
                <Button
                    onClick={goToMap}
                    style={MAP_TAB_STYLE}
                >
                    <T k="Go To MAP" />
                </Button>
            )}
        </div>
    );
};

export default memo(FloatingActionsLayout);
